import type {
    InstructionGroupAttributes,
} from "@/types/landing";

import styles from "./Instruction.module.css"
import { CmsImage } from "@/components/common/CmsImage";

type InstructionComponent = ({
    instructionGroup,
}: {
    instructionGroup: InstructionGroupAttributes | undefined;
}) => React.ReactElement;

export const Instruction: InstructionComponent = ({ instructionGroup }) => {
    return (
        <div className={styles.instructionGroup}>
            {instructionGroup?.instructions?.map((instruction) => (
                <div className={styles.instructionContainer} key={instruction.id}>
                    <div className={styles.iconContainer}>
                        <CmsImage cmsMedia={instruction.icon || null}
                                  desiredHeight={35}
                                  maxWidth={35}/>
                    </div>
                    <p>{instruction.text}</p>
                </div>
            ))}
        </div>
    );
};
